import { render } from "./TheDetailPageBody.vue?vue&type=template&id=b7e82e88&ts=true"
import script from "./TheDetailPageBody.vue?vue&type=script&lang=ts"
export * from "./TheDetailPageBody.vue?vue&type=script&lang=ts"

import "./TheDetailPageBody.vue?vue&type=style&index=0&id=b7e82e88&lang=scss"

import exportComponent from "/Users/hirosuke-pi/projects/vr-jmof-front-2020/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__